import React from 'react';
import { useSession } from 'next-auth/react';
import Breadcrumb from './Breadcrumb';
import Brand from './Brand';

const Header = () => {
  const { status, data } = useSession();

  if (status === 'loading' || !data) {
    return null;
  }

  return (
    <div className="sticky top-0 z-40 border-b border-border bg-background shadow-sm">
      <div className="flex h-16 items-center gap-3 px-4 sm:px-6 lg:px-8">
        {/* Left: Logo */}
        <div className="flex items-center flex-shrink-0">
          <Brand />
        </div>

        {/* Separator */}
        <span className="text-muted-foreground select-none ml-4">/</span>

        {/* Center/Right: Breadcrumb Navigation */}
        <div className="flex-1">
          <Breadcrumb />
        </div>
      </div>
    </div>
  );
};

export default Header;
